import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../../configs/WebServiceUrl";
import {
  buildWelcomeTemplateBody,
  getMobileFromStudent,
  mapBotAccessStatus,
  shouldSendEmail,
  shouldSendFailedEmail,
  shouldSendSMS,
  shouldSendWhatsapp,
} from "./utils";

export const registerStudent = createAsyncThunk(
  "student/registerStudent",
  async (studentData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/student/create-individual-student`,
        studentData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      // Notifications moved to OTP verification page (sent after mobile verification)
      // const state = thunkAPI.getState();
      // const promises = [];
      // if (shouldSendWhatsapp(state)) {
      //   promises.push(
      //     thunkAPI.dispatch(sendWelcomeTemplate(studentData)).unwrap()
      //   );
      // }
      // if (shouldSendEmail(state)) {
      //   promises.push(
      //     thunkAPI.dispatch(sendWelcomeEmail(studentData)).unwrap()
      //   );
      // }
      // if (shouldSendSMS(state)) {
      //   promises.push(thunkAPI.dispatch(sendWelcomeSMS(studentData)).unwrap());
      // }
      // await Promise.all(promises);

      return response.data;
    } catch (error) {
      // return thunkAPI.rejectWithValue(
      //   error.response?.data?.error || "Registration failed"
      // );
      const state = thunkAPI.getState();
      const promises = [];
      if (shouldSendFailedEmail(state)) {
        promises.push(thunkAPI.dispatch(sendFailedEmail(studentData)).unwrap());
      }
      await Promise.all(promises);
      return thunkAPI.rejectWithValue(
        error.response?.data?.error || "Registration failed"
      );
    }
  }
);

export const registerTeacher = createAsyncThunk(
  "teacher/registerTeacher",
  async (teacherData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/adminauth/individual-registration`,
        teacherData,
        { headers: { "Content-Type": "application/json" } }
      );

      // Notifications moved to OTP verification page (sent after mobile verification)
      // const state = thunkAPI.getState();
      // const promises = [];
      // if (shouldSendWhatsapp(state)) {
      //   promises.push(
      //     thunkAPI.dispatch(sendWelcomeTemplate(teacherData)).unwrap()
      //   );
      // }
      // if (shouldSendEmail(state)) {
      //   promises.push(
      //     thunkAPI.dispatch(sendWelcomeEmail(teacherData)).unwrap()
      //   );
      // }
      // if (shouldSendSMS(state)) {
      //   promises.push(thunkAPI.dispatch(sendWelcomeSMS(teacherData)).unwrap());
      // }
      // await Promise.all(promises);
      return response.data;
    } catch (error) {
      // return thunkAPI.rejectWithValue(
      //   error.response?.data?.error || "Registration failed"
      // );
      const state = thunkAPI.getState();
      const promises = [];
      if (shouldSendFailedEmail(state)) {
        promises.push(thunkAPI.dispatch(sendFailedEmail(teacherData)).unwrap());
      }
      await Promise.all(promises);
      return thunkAPI.rejectWithValue(
        error.response?.data?.error || "Registration failed"
      );
    }
  }
);

export const sendWelcomeTemplate = createAsyncThunk(
  "teacher/sendWelcomeTemplate",
  async (teacherData, { rejectWithValue }) => {
    try {
      const body = buildWelcomeTemplateBody(teacherData);

      const response = await axios.post(
        `https://web1024.docmaster.in:4001/webhook/sendTemplateToMultipleUsers`,
        body,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to send welcome template"
      );
    }
  }
);
export const sendWelcomeEmail = createAsyncThunk(
  "teacher/sendWelcomeEmail",
  async (teacherData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/adminauth/send-registration-email`,
        {
          to: teacherData.email,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to send welcome email"
      );
    }
  }
);
export const sendFailedEmail = createAsyncThunk(
  "teacher/sendFailedEmail",
  async (teacherData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/adminauth/send-rgfailed-email`,
        {
          to: teacherData.email,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to send failure email"
      );
    }
  }
);

export const sendWelcomeSMS = createAsyncThunk(
  "student/sendWelcomeSMS",
  async (studentData, thunkAPI) => {
    try {
      const mobile = getMobileFromStudent(studentData);

      const response = await axios.post(
        `${BASE_URL}/api/adminauth/send-registration-sms`,
        // `http://localhost:5010/api/adminauth/send-registration-sms`,
        {
          mobile,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to send welcome SMS"
      );
    }
  }
);

export const getClassesList = createAsyncThunk(
  "student/getClassesList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "https://web1024.docmaster.in:5007/api/school/quiz/admin/classes"
        // {
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        // }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Registration failed"
      );
    }
  }
);
export const getTopicsList = createAsyncThunk(
  "student/getTopicsList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "https://web1024.docmaster.in:5007/api/school/syllabus/published-syllabus"
        // {
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        // }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Registration failed"
      );
    }
  }
);
export const getGroupsList = createAsyncThunk(
  "student/getGroupsList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "https://web1024.docmaster.in:5007/api/school/quiz/admin/groups" // {
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        // }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Registration failed"
      );
    }
  }
);
export const getBotAccessList = createAsyncThunk(
  "bot/getBotAccessList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/api/adminauth/bot-access`);
      const mapped = mapBotAccessStatus(response.data.data);
      return {
        original: response.data.data,
        mappedStatus: mapped,
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch bot access list"
      );
    }
  }
);
